import { useWorkspace } from "@/contexts/WorkspaceContext";
import { useSubscriptionStatus } from "@/hooks/useSubscriptionStatus";
import { SubscriptionLockOverlay } from "@/components/SubscriptionLockOverlay";
import { Skeleton } from "@/components/ui/skeleton";
import AdminDashboard from "./admin/AdminDashboard";
import WorkspaceOwnerDashboard from "./WorkspaceOwnerDashboard";

export default function Dashboard() {
  const { isSuperAdmin, isWorkspaceOwner, isWorkspaceAdmin, isMember, isImpersonating } = useWorkspace();
  const { canAccessFeatures, isLoading: subscriptionLoading } = useSubscriptionStatus();

  // Super admins NOT impersonating a workspace see admin dashboard
  if (isSuperAdmin && !isImpersonating) {
    return <AdminDashboard />;
  }

  // Super admin impersonating OR workspace owner/admin/member see workspace dashboard
  if (isImpersonating || isWorkspaceOwner || isWorkspaceAdmin || isMember) {
    if (subscriptionLoading) {
      return (
        <div className="space-y-6">
          <Skeleton className="h-8 w-48" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Skeleton className="h-32" />
            <Skeleton className="h-32" />
            <Skeleton className="h-32" />
            <Skeleton className="h-32" />
          </div>
        </div>
      );
    }

    // Existing subscription gate (regular workspaces & active auto workspaces still go through it)
    if (!canAccessFeatures) {
      return <SubscriptionLockOverlay />;
    }

    return <WorkspaceOwnerDashboard />;
  }

  return <WorkspaceOwnerDashboard />;
}
